import { styled } from '@mui/material/styles';

interface StyledLiProps {
  visible?: boolean;
}

export const StyledLi = styled('li', {
  name: 'FieldToggle',
  overridesResolver: (_props, styles) => styles.root,
})<StyledLiProps>(({ theme, visible }) => ({
  display: visible ? 'flex' : 'none',
  justifyContent: 'space-between',
  paddingLeft: 0,
  '& svg': {
    cursor: 'move',
  },
  '&.drag-active': {
    background: 'transparent',
    color: 'transparent',
    outline: `1px solid ${theme.palette.action.selected}`,
    '& .MuiSwitch-root, & svg': {
      visibility: 'hidden',
    },
  },
}));
